export default "__VITE_ASSET__BjMRuvCl__"